import script from "./ProductCom.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductCom.vue?vue&type=script&lang=ts&setup=true"

import "./ProductCom.vue?vue&type=style&index=0&id=5c680bbc&lang=scss&scoped.=true"

const __exports__ = script;

export default __exports__